import { createFileRoute } from "@tanstack/react-router";
import AnalisisCompleto from "@/pages/AnalisisCompleto";
import { analisisCompletoHead } from "@/lib/analisisCompletoSeo";

export const Route = createFileRoute("/detector-de-fugas")({
  head: () => analisisCompletoHead("es"),
  component: AnalisisCompleto,
});
